import { css as _css } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import AdvancedOption from '../../enums/advanced-option';
import * as commonStyles from './common.style';
import * as styles from './parent-panel.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ParentPanel = props => ___EmotionJSX("div", {
  css: /*#__PURE__*/_css([commonStyles.container, styles.container])
}, props.disabled && ___EmotionJSX("div", {
  css: styles.disabledPanelOverlay
}), props.disabled && ___EmotionJSX("div", {
  css: styles.disabledPanelText
}, "Sorry, overlays are not available for this address"), ___EmotionJSX("div", {
  css: /*#__PURE__*/_css([commonStyles.title, styles.title])
}, "Need more info? We've got you covered."), ___EmotionJSX("div", {
  css: styles.itemsContainer
}, AdvancedOption.map(item => ___EmotionJSX("div", {
  css: styles.item,
  key: item.key
}, ___EmotionJSX("div", {
  css: styles.itemIconContainer
}, ___EmotionJSX(item.icon, {
  css: styles.itemIcon,
  size: "small"
})), ___EmotionJSX("div", {
  css: styles.itemTextContainer
}, ___EmotionJSX("button", {
  css: styles.itemTitle,
  type: "button",
  onClick: () => {
    props.onSelect(item.key);
  }
}, item.title), ___EmotionJSX("div", {
  css: styles.itemDescription
}, item.description))))));
ParentPanel.propTypes = {
  onSelect: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
ParentPanel.defaultProps = {
  disabled: false
};
export default ParentPanel;